import { createActions } from 'redux-actions';

export const { setFiltersCount } = createActions('SET_FILTERS_COUNT');
